<script lang="ts">
	import { AlertV2, ButtonV2 } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';
	import { real_id } from 'src/helpers/interface_helpers';
	import { camera_setup_prompt } from 'src/components/Camera/stores/camera_setup_prompt';
	import NoResults from './NoResults.svelte';

	export let deviceId: string;
	export let variant: 'banner' | 'empty' = 'banner';
	let className = '';
	export { className as class };

	$: content = {
		icon: 'fa-light fa-lock',
		title: $format('camera_setup_cta_title', { default: 'Set up cloud recordings' }),
		description: $format('camera_setup_cta_description', {
			default: 'Password setup is required to enable encrypted cloud recordings.',
		}),
	};
	$: buttonLabel = $format('camera_setup_cta_button', { default: 'Setup Cloud Recordings' });

	const handleClick = () => camera_setup_prompt.open(real_id(deviceId));
</script>

{#if variant === 'banner'}
	<AlertV2
		class={`mb-s ${className}`.trim()}
		isHeadingBold
		customIcon="fas fa-lock text-primary"
		heading={content.title}
		message={content.description}
	>
		<ButtonV2 slot="bottom" size="m" on:click={handleClick} aria-label={buttonLabel}>
			{buttonLabel}
		</ButtonV2>
	</AlertV2>
{:else}
	<NoResults noResultsFound={content} />
	<div class="d-flex justify-content-center mt-m">
		<ButtonV2 size="m" on:click={handleClick} aria-label={buttonLabel}>
			{buttonLabel}
		</ButtonV2>
	</div>
{/if}
